// extracted by mini-css-extract-plugin
export default {"criteriaContainer":"GripAnalysisDetails_criteriaContainer__7nWt","spinAround":"GripAnalysisDetails_spinAround_BvHoC"};